export const checkIfPriceGrowthRelationTypeDisabled = (values: any) => {
  const purchaseDate = values.stages[1].date;
  const finishDate = values.stages[2].date;

  const purchaseDateValue = new Date(purchaseDate);
  const finishDateValue = new Date(finishDate);
  const purchaseYearMonth =
    purchaseDateValue.getFullYear() * 12 + purchaseDateValue.getMonth();
  const finishYearMonth =
    finishDateValue.getFullYear() * 12 + finishDateValue.getMonth();

  return purchaseYearMonth > finishYearMonth;
};
